import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import GAlign from "../../../Components/GAlign";
import Typography from "../../../Components/Typography/Typography";
import TwoColumn from "../../../Components/TwoColumn";
import WhatMakesUsDifferent from "../../../Components/WhatMakesUsDifferent";
import GetInTouch from "../../../Components/GetInTouch";
import { data } from "../../../Data/data";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import Img from "../../../assets/images/image";
import Banner from "../../../Components/Banner";
import Rewards from "../../About/_components/Rewards";
import useMediaQuery from "../../../hooks/useMediaQuery";
import Animation from "../../../animations/Animation";
import HeroSection from "../../../Components/HeroSection/HeroSection";

export default function StaffAugmentation() {
   const [technologies, setTechnologies] = useState([]);
   const mdBreakpoint = useMediaQuery("(min-width: 1200px)");
   const lgBreakpoint = useMediaQuery("(min-width: 991px)");

   const technologiesMap = () => {
      let arr = [];
      for (const key in Img.technologies) {
         arr.push(key);
      }
      setTechnologies(arr);
   };

   useEffect(() => {
      technologiesMap();
      return () => {};
   }, []);

   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Best IT staff augmentation company in India for business</title>
            <meta name="description" content="We are an IT Staff Augmentation company, providing services for your projects with our highly skilled and qualified professional developers." />
            <link rel="canonical" href="https://www.witmates.com/staff_augmentation" />
         </Helmet>
         <Style>
            <HeroSection
               image={Img.staffAugmentationBanner}
               heading={
                  <>
                     <h1>
                        <span className="witmates-theme-color">10X</span> Your <span className="witmates-theme-color">Team’s</span> <br /> Efficiency <span className="witmates-theme-color">with</span>{" "}
                        Our <br />
                        <span className="witmates-theme-color">IT staff augmentation services</span>
                     </h1>
                  </>
               }
               description={
                  <>
                     Finding the right talent with the required skill set for your IT projects is tough, and we understand that. At Witmates, we provide IT staff augmentation services for your
                     projects with access to a pool of highly skilled and experienced professionals that seamlessly integrate into your existing team, complementing your strengths and accelerating
                     your project's progress.
                  </>
               }
               link
            />
            <Container>
               <Row>
                  <Col className="mt30 mb30 pt30 pb30 mobMt20 mobMb20">
                     <Animation slide bottom>
                        <GAlign align="center">
                           <Typography element="span" fontWeight={600} className="fs60 tabHeadingFontSize mobHeadingFontSize" syne>
                              A leading IT Staff augmentation company providing qualified IT {lgBreakpoint && <br />}{" "}
                              <Typography element="span" className="colorOrange" syne>
                                 resources across the globe
                              </Typography>{" "}
                              the Globe
                           </Typography>
                        </GAlign>
                     </Animation>
                  </Col>
               </Row>
            </Container>
            <div className="d-flex justify-content-center align-items-center mobPt0 pt40">
               <TwoColumn
                  image={Img.expertIiProfessionals}
                  heading={
                     <>
                        Expert IT <br />
                        Professionals
                     </>
                  }
                  pageName="EXPERTISE"
                  buttonName="Lets talk"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={`We offer a wide range of expert IT staff augmentation services across various domains and technologies. For all kinds of software development, we have an extensive network of skilled IT professional experts that enables us to find the perfect match for your specific project requirements.`}
               />
            </div>
            <div className="d-flex justify-content-center align-items-center mobPt60 pt100">
               <TwoColumn
                  reverse
                  image={Img.flexibleStaffingSolutions}
                  heading={
                     <>
                        Flexible Staffing <br /> Solutions
                     </>
                  }
                  pageName="FLEXIBILITY"
                  buttonName="Lets talk"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={`Our IT staff augmentation services are flexible and scalable. It allows you to quickly ramp up or down your team size as per project demands. Whether you need short-term assistance or long-term support, we are here to provide you with the right professionals to meet your goals.`}
               />
            </div>
            <div className="d-flex justify-content-center align-items-center mobPt40 pt100">
               <TwoColumn
                  image={Img.seamlessIntegration}
                  heading={
                     <>
                        Seamless <br /> Integration
                     </>
                  }
                  pageName="INTEGRATION"
                  buttonName="Lets talk"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={`Our skilled professionals are able to seamlessly integrate with your existing team, and adapt your work culture and processes. We ensure a smooth onboarding process, minimizing disruptions and maximizing productivity from day one.`}
               />
            </div>
            <div className="d-flex justify-content-center align-items-center mobPt60 mobPb40 pt100 pb100">
               <TwoColumn
                  reverse
                  image={Img.qualityAssurance}
                  heading={<>Quality Assurance</>}
                  pageName="QUALITY"
                  buttonName="Lets talk"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={
                     <>
                        We thoroughly screen and evaluate all our candidates to ensure they possess the necessary skills and experience that are required for your specific projects. <br />
                        <br />
                        Witmates Technologies excels in IT staff augmentation companies, ensuring your success with top-tier professionals dedicated to delivering high-quality results.
                     </>
                  }
               />
            </div>
            <WhatMakesUsDifferent data={data.staffAugmentationData} height="415px" />
            <Container className="mobPt20 pt100 mt30 mb30">
               <Animation slide bottom>
                  <div className="text-center">
                     <Typography element="span" className="fs60 tabHeadingFontSize mobHeadingFontSize colorOrange" syne fontWeight={600}>
                        Technologies
                     </Typography>
                     <Typography className="d-block font-18 my-3 colorBlack" DMSans element="span">
                        We are constantly learning and adopting new technologies to stay ahead of the <br /> curve and provide our clients with the best possible solutions.
                     </Typography>
                  </div>
               </Animation>

               <div className="row justify-content-center align-items-center pt100 mobPt50 gy5">
                  {technologies.map((technology, index) => (
                     <div key={index} className={`${mdBreakpoint ? "columnClass" : "col-6 col-sm-6 col-md-3"} d-flex justify-content-center`}>
                        <Animation zoom>
                           <div key={"technology-" + technology} className="technologies-circle">
                              <img src={Img.technologies[technology]} alt="no img" className="d-block mx-auto" />
                           </div>
                        </Animation>
                     </div>
                  ))}
               </div>
            </Container>
            <div className="pt90 mobPt10">
               <Rewards />
            </div>
            <GetInTouch />
         </Style>
      </div>
   );
}

const Style = styled.div`
   .technologies-circle {
      width: 126px;
      height: 126px;
      background-color: #0e0e0e;
      display: block;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
   }
   .rowClass {
      display: flex;
      flex-wrap: wrap;
   }
   .columnClass {
      max-width: 14.2%;
      flex-basis: 14.2%;
   }
`;
